import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { useEffect } from "react"
import { redirectRetiredAuthUrl } from './utils/retiredAuthPaths';

// Global Styles - Design System Entry Point
import './styles/globals.css';

redirectRetiredAuthUrl();

const Main = () => {
  const setFavicon = () => {
    const link = document.createElement("link");
    link.rel = "icon";
    link.href = import.meta.env.VITE_FAVICON_URL;
    document.head.appendChild(link);
  };

  useEffect(setFavicon, [])
  return (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

ReactDOM.createRoot(document.getElementById('root')).render(<Main />);